import type { SVGProps } from 'react'

const RetailerContentIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="60"
    height="60"
    viewBox="0 0 60 60"
    fill="none"
    {...props}
  >
    <ellipse cx="30" cy="30" rx="30" ry="30" fill="currentColor" />
    <path
      d="M36.667 15.332L42.0003 20.6654L36.667 25.9987"
      stroke="#2563EB"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18 28.668V26.0013C18 24.5868 18.5619 23.2303 19.5621 22.2301C20.5623 21.2299 21.9188 20.668 23.3333 20.668H42"
      stroke="#2563EB"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M23.3333 44.6667L18 39.3333L23.3333 34"
      stroke="#2563EB"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M42 31.332V33.9987C42 35.4132 41.4381 36.7697 40.4379 37.7699C39.4377 38.7701 38.0812 39.332 36.6667 39.332H18"
      stroke="#2563EB"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default RetailerContentIcon
